import { Injectable } from '@angular/core';
import { BodyScrollLockService } from '../dom/body-scroll-lock.service';

@Injectable({
  providedIn: 'root',
})

export class ModalService {
  private modals: { [key: string]: { open: boolean; data?: any; canClose?: boolean; isEdition?: boolean } } = {};

  constructor(private bodyScrollLock: BodyScrollLockService) {}

  openModal(type: string, data?: any, isEdition: boolean = false) {
    const wasOpen = this.isModalOpen(type);
    this.modals[type] = { open: true, data, canClose: true, isEdition };
    if (!wasOpen) {
      this.bodyScrollLock.lock();
    }
  }

  closeModal(type: string) {
    if (this.modals[type] && this.modals[type].canClose !== false) {
      const wasOpen = this.modals[type].open;
      this.modals[type].open = false;
      this.modals[type].data = undefined;
      if (wasOpen) {
        this.bodyScrollLock.unlock();
      }
    }
  }

  setCanClose(type: string, canClose: boolean) {
    if (this.modals[type]) {
      this.modals[type].canClose = canClose;
    }
  }

  getIsEdition(type: string): boolean {
    return !!this.modals[type]?.isEdition;
  }

  isModalOpen(type: string): boolean {
    return !!this.modals[type]?.open;
  }

  getData<T = any>(type: string): T | undefined {
    return this.modals[type]?.data as T;
  }
}
